var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_28041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0664062 15.8174V33.4368L11.3931 24.6271L0.0664062 15.8174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6172 11.2334V16.6506L32.9623 14.0488L29.6172 11.2334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6419 1.15385C17.2712 0.841944 16.7298 0.841944 16.3591 1.15385L13.7178 3.37694H20.2832L17.6419 1.15385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38317 11.2334L1.03809 14.0488L4.38317 16.6506V11.2334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3574 25.623L1.4043 34.9199H32.5958L20.6427 25.623H13.3574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6064 24.6272L33.9332 33.4369V15.8174L22.6064 24.6272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7492 12.8311C15.9412 12.8311 15.1055 13.6166 15.1055 14.9312C15.1055 16.2677 15.9207 17.1655 16.6821 17.1655C17.4839 17.1655 18.1414 16.2274 18.1886 15.0479L18.1899 14.7975C18.1541 13.6338 17.5718 12.8311 16.7492 12.8311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6426 23.6309L27.625 18.2001V6.36523C27.625 5.81512 27.179 5.36914 26.6289 5.36914H7.37109C6.82098 5.36914 6.375 5.81512 6.375 6.36523V18.2002L13.3574 23.6309H20.6426ZM9.97807 16.8513C9.5024 15.0427 9.7416 13.1361 10.6517 11.4826C11.5614 9.82978 13.0438 8.60711 14.826 8.0398C16.7062 7.44115 18.7025 7.61752 20.4471 8.53639C22.1919 9.45532 23.4666 11.001 24.0363 12.8887C24.0395 12.8989 24.0424 12.9093 24.0451 12.9197C24.4238 14.3381 24.3117 15.6771 23.6816 17.2612C23.2557 18.332 22.2116 19.4762 20.5584 19.4762C19.9587 19.4762 19.3835 19.2302 18.939 18.7835C18.8338 18.6777 18.739 18.5626 18.6542 18.4406C18.0959 18.8947 17.4189 19.1574 16.6819 19.1574C15.7192 19.1574 14.7831 18.69 14.1138 17.8751C13.4684 17.0894 13.1131 16.0438 13.1131 14.9309C13.1131 13.813 13.4912 12.7786 14.1779 12.0183C14.8549 11.2686 15.7921 10.8386 16.749 10.8386C17.2753 10.8386 17.7754 10.964 18.2247 11.2003C18.3119 10.7386 18.7166 10.3898 19.2026 10.3898H19.2077C19.7578 10.3925 20.2016 10.8407 20.1989 11.3908L20.1714 16.9248C20.1706 17.0947 20.2378 17.2642 20.3512 17.3781C20.3904 17.4176 20.4696 17.4838 20.5584 17.4838C21.3622 17.4838 21.7158 16.8132 21.8304 16.5249C22.2957 15.355 22.3839 14.4339 22.1244 13.4487C21.7078 12.083 20.783 10.9648 19.5188 10.299C18.2502 9.63083 16.798 9.50273 15.4303 9.93802C12.7343 10.7963 11.1857 13.6103 11.9048 16.3445C12.5019 18.6151 14.5543 20.2461 16.8959 20.3109C17.4457 20.3261 17.8793 20.7842 17.864 21.3341C17.8491 21.8747 17.4061 22.3027 16.8688 22.3027C16.8595 22.3027 16.8502 22.3025 16.8408 22.3023C15.2971 22.2596 13.7734 21.7113 12.5501 20.7582C11.2792 19.7682 10.3899 18.4172 9.97807 16.8513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_28041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0 0.919922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.01b8df3556c5c22fd65bb3faf59895c3.svg";
export { ForwardRef as ReactComponent };